module.exports = __webpack_public_path__ + "static/media/tomato.96534e37.png";